// client/src/components/plataforma/contas/ContaConfiguracoesPage.js

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ContaSettingsPanel from './ContaSettingsPanel';
import { ArrowLeft, Settings } from 'lucide-react';
// ✅ 1. Importar o hook para buscar os dados da conta
import { useAccountById } from '../../../hooks/useAccounts';

const ContaConfiguracoesPage = () => {
    const { id: contaId } = useParams();
    const navigate = useNavigate();

    // ✅ 2. Buscar os detalhes da conta para usar no título
    const { data: accountDetails } = useAccountById(contaId);

    return (
        <div className="page-management-container">
            <div className="page-header">
                <div className="flex items-center gap-4">
                    <button onClick={() => navigate(-1)} className="action-button action-button-secondary">
                        <ArrowLeft size={16} className="icon" /> Voltar
                    </button>
                    {/* ✅ 3. Título agora é renderizado aqui, ao lado do botão */}
                    <h1 className="page-title">
                        <Settings className="icon-title"/>
                        Configurações da Conta: {accountDetails?.name || '...'}
                    </h1>
                </div>
            </div>
            
            {/* O painel agora só renderiza o conteúdo, sem o cabeçalho */}
            <ContaSettingsPanel accountId={contaId} isMyAccount={false} />
        </div>
    );
};

export default ContaConfiguracoesPage;